"use client";

import SectionHeader from "@/components/ui/section-header";
import {
  ProConsColumn,
  type ProConsItem,
} from "@/components/sections/editorial/proxy-server/_shared/pros-cons-column";

const GOOD_FITS: ProConsItem[] = [
  {
    label: "Global web scraping",
    body: "Standard HTTP, HTTPS, or SOCKS5 clients collecting public data at scale.",
  },
  {
    label: "AI and LLM data collection",
    body: "Geo-diverse public data for training, fine-tuning, or retrieval pipelines.",
  },
  {
    label: "Localized SEO and SERP monitoring",
    body: "Country and city-level targeting to see rankings the way local users do.",
  },
  {
    label: "Price and availability monitoring",
    body: "Recurring, location-specific checks across large sets of listings.",
  },
  {
    label: "Market research and brand protection",
    body: "Region-specific content, pricing, and marketplace monitoring.",
  },
  {
    label: "Rotating or sticky session workflows",
    body: "Per-GB pricing with session control built into every access point.",
  },
];

const CONSIDER_OTHER: ProConsItem[] = [
  {
    label: "You want a managed scraping API",
    body: "Something that renders pages and returns parsed, structured records instead of raw proxy access.",
  },
  {
    label: "You need one fixed, allowlisted IP",
    body: "Residential access points draw from a rotating pool with optional sticky sessions, not a permanently dedicated static IP.",
  },
  {
    label: "Your workflow doesn't need a proxy",
    body: "If you're not routing outbound requests through a third-party IP, this isn't the right product.",
  },
  {
    label: "You need access without verification",
    body: "Tier 1 KYC is required for every account before proxy access is enabled.",
  },
  {
    label: "You want a consumer VPN",
    body: "Proxidize builds B2B proxy infrastructure, not a personal VPN app.",
  },
];

export default function ResidentialWhoPlansFit() {
  return (
    <section
      aria-labelledby="residential-who-plans-fit-heading"
      className="border-border py-section-sm relative border-b"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-10 max-w-3xl">
          <SectionHeader
            eyebrow="Fit Check"
            id="residential-who-plans-fit-heading"
            heading="Who these plans fit"
            body="Proxidize residential plans fit teams that operate their own scraper, browser automation, rank tracker, AI data pipeline, price-monitoring system, or research workflow and need a managed proxy network underneath it."
          />
        </div>

        <div className="grid gap-2 sm:gap-4 md:grid-cols-2">
          <ProConsColumn heading="Good fits" items={GOOD_FITS} positive />
          <ProConsColumn
            heading="Consider another architecture"
            items={CONSIDER_OTHER}
            positive={false}
          />
        </div>
      </div>
    </section>
  );
}
